import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class OfferService extends CrudService {
  constructor() {
    super(API_RESOURCE.OFFER)
  }

  //Offer Related

  patchOffer = async ({ offerId, payload }) => {
    const response = await axios.patch(`${this.resource}/${offerId}`, payload)

    return response.data
  }

  batchUpdateOffers = async ({ file }) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.put(`${this.resource}/batchUpdate`, form)

    return response.data
  }

  uploadOffers = async ({ file }) => {
    const form = new FormData()
    form.append('file', file)

    const response = await axios.post(`${this.resource}/upload`, form)

    return response.data
  }

  importOffer = async ({ file, offerType }) => {
    if (!file) {
      throw new Error('Missing File Type or File')
    }
    const form = new FormData()
    form.append('file', file)
    form.append('offerType', offerType)

    const response = await axios.post(`${this.resource}/import`, form)

    return response.data
  }

  getAllOfferRevisions = async ({ offerId }) => {
    const response = await axios.get(`${this.resource}/${offerId}/revisions`)
    return response.data
  }

  //List

  getMergedDocument = async ({ offerId, tabs, fileTypes, otherDocs, offerSummaryFile }) => {
    if (offerSummaryFile) {
      const form = new FormData()
      form.append('offerSummaryFile', offerSummaryFile)
      form.append('tabs', JSON.stringify(tabs))
      form.append('fileTypes', JSON.stringify(fileTypes))
      form.append('otherDocs', JSON.stringify(otherDocs ?? []))

      const response = await axios.post(`${this.resource}/${offerId}/mergedDocuments`, form, {
        responseType: 'blob',
      })

      return response.data
    }

    const response = await axios.post(
      `${this.resource}/${offerId}/mergedDocuments`,
      { tabs, fileTypes, otherDocs },
      {
        responseType: 'blob',
      }
    )

    return response.data
  }

  closeOffer = async ({ offerId, data }) => {
    console.log('offerId, data', offerId, data)
    const response = await axios.put(`${this.resource}/${offerId}/close`, data)

    return response.data
  }

  getHandoverFormDocument = async (offerId) => {
    const response = await axios.get(
      `${this.resource}/${offerId}/handover-form/download`,
      {},
      {
        responseType: 'blob',
      }
    )

    return response.data
  }

  saveBooking = async ({ offerId, data }) => {
    const response = await axios.put(`${this.resource}/${offerId}/booking`, data)

    return response.data
  }

  // get all documents links and name in sharepoint
  getSharepointDocumentLinks = async (offerId) => {
    const response = await axios.get(`${this.resource}/sharepoint/getAllDocumentsLink/${offerId}`)
    return response.data.data
  }
}

export default OfferService
